import {Id, Url} from './basics'
import {IEntity} from './entity'
import { mapPaginationFromApi } from './paginated'
import { mapDateFromApi } from 'src/core/utils'

export enum SignatureStatus {
  READY = 'READY',
  EXPIRED = 'EXPIRED',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  FAILED = 'FAILED',
  PENDING_VALIDATION = 'PENDING_VALIDATION',
}

export interface ISignature extends IEntity {
  created_at: Date;
  expire_at: Date;
  name: string;
  description: string;
  content_type: string;
  language: string;
  permalink: string;
  category_document: string;
  category_produit: string;
  category_principale: string;
  category_type?: string;
  fileUrl: Url;
  fileToSignUrl: Url;
  fileName: string;
  status: SignatureStatus;
  external_id: Id;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  signedFileUrl: Url;
  document_id: string;
  doc_type?: string;
}

export const mapSignatureFromApi = (apiSignatures: any): ISignature => ({
  ...apiSignatures,
  created_at: mapDateFromApi(apiSignatures.created_at),
  expire_at: mapDateFromApi(apiSignatures.expire_at),
});

export const mapSignaturePaginationFromApi = mapPaginationFromApi<ISignature>(mapSignatureFromApi)


// WEBPACK FOOTER //
// ./src/type/signature.ts